var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3617 26.6897H0.148926V1.07373H26.3617V26.6897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.297872 1.21931V26.5442H26.2128V1.21931H0.297872ZM0 0.928223H26.5106V26.8353H0V0.928223Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2127 1.21924H0.297852V8.20541H26.2127V1.21924Z",
    fill: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0638 1.36475H0.446777V8.05983H26.0638V1.36475Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7234 9.66113H6.25531V14.0275H10.7234V9.66113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5744 9.80664H6.40424V13.8819H10.5744V9.80664Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95747 18.9761H1.48938V23.3424H5.95747V18.9761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80852 19.1216H1.63831V23.1968H5.80852V19.1216Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95747 14.3184H1.48938V18.6847H5.95747V14.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80852 14.4639H1.63831V18.5391H5.80852V14.4639Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4894 9.66113H11.0213V14.0275H15.4894V9.66113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3404 9.80664H11.1702V13.8819H15.3404V9.80664Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7234 18.9761H6.25531V23.3424H10.7234V18.9761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5744 19.1216H6.40424V23.1968H10.5744V19.1216Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7234 14.3184H6.25531V18.6847H10.7234V14.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5744 14.4639H6.40424V18.5391H10.5744V14.4639Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2553 9.66113H15.7872V14.0275H20.2553V9.66113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1064 9.80664H15.9362V13.8819H20.1064V9.80664Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4894 18.9761H11.0213V23.3424H15.4894V18.9761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3404 19.1216H11.1702V23.1968H15.3404V19.1216Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4894 14.3184H11.0213V18.6847H15.4894V14.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3404 14.4639H11.1702V18.5391H15.3404V14.4639Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0212 9.66113H20.5532V14.0275H25.0212V9.66113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8723 9.80664H20.7021V13.8819H24.8723V9.80664Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2553 18.9761H15.7872V23.3424H20.2553V18.9761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1064 19.1216H15.9362V23.1968H20.1064V19.1216Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2553 14.3184H15.7872V18.6847H20.2553V14.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1064 14.4639H15.9362V18.5391H20.1064V14.4639Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0212 14.3184H20.5532V18.6847H25.0212V14.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8723 14.4639H20.7021V18.5391H24.8723V14.4639Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4255 27.7087C23.6674 27.7064 22.9334 27.4472 22.3489 26.9754C21.7643 26.5035 21.3653 25.8481 21.2199 25.1209C21.0744 24.3937 21.1915 23.6398 21.5512 22.9875C21.911 22.3353 22.491 21.8252 23.1925 21.5441C23.8941 21.263 24.6736 21.2283 25.3984 21.446C26.1231 21.6637 26.7481 22.1203 27.1669 22.738C27.5858 23.3556 27.7724 24.0961 27.6951 24.8332C27.6178 25.5702 27.2813 26.2583 26.743 26.7801C26.4387 27.0768 26.0772 27.3117 25.6794 27.4711C25.2816 27.6305 24.8555 27.7112 24.4255 27.7087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4255 21.5959C23.8364 21.5959 23.2605 21.7666 22.7707 22.0864C22.2808 22.4063 21.899 22.8609 21.6736 23.3928C21.4481 23.9247 21.3891 24.51 21.5041 25.0746C21.619 25.6393 21.9027 26.158 22.3193 26.5651C22.7358 26.9722 23.2666 27.2494 23.8444 27.3617C24.4222 27.474 25.0212 27.4164 25.5655 27.1961C26.1097 26.9758 26.575 26.6027 26.9023 26.124C27.2296 25.6453 27.4043 25.0825 27.4043 24.5068C27.4043 23.7347 27.0904 22.9943 26.5318 22.4484C25.9732 21.9025 25.2155 21.5959 24.4255 21.5959ZM24.4255 21.0137C25.1325 21.0137 25.8236 21.2185 26.4114 21.6024C26.9992 21.9862 27.4574 22.5317 27.7279 23.17C27.9985 23.8083 28.0693 24.5106 27.9313 25.1882C27.7934 25.8658 27.453 26.4882 26.9531 26.9767C26.4532 27.4653 25.8163 27.7979 25.1229 27.9327C24.4295 28.0675 23.7108 27.9983 23.0577 27.7339C22.4045 27.4696 21.8462 27.0218 21.4535 26.4474C21.0607 25.873 20.8511 25.1976 20.8511 24.5068C20.8511 23.5803 21.2277 22.6919 21.898 22.0368C22.5684 21.3817 23.4775 21.0137 24.4255 21.0137Z",
    fill: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4255 23.3423V24.8414H26.314",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85104 4.71251C7.50908 4.71251 8.04252 4.19121 8.04252 3.54815C8.04252 2.90509 7.50908 2.38379 6.85104 2.38379C6.19299 2.38379 5.65955 2.90509 5.65955 3.54815C5.65955 4.19121 6.19299 4.71251 6.85104 4.71251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85104 4.71251C7.50908 4.71251 8.04252 4.19121 8.04252 3.54815C8.04252 2.90509 7.50908 2.38379 6.85104 2.38379C6.19299 2.38379 5.65955 2.90509 5.65955 3.54815C5.65955 4.19121 6.19299 4.71251 6.85104 4.71251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85102 4.56693C7.42681 4.56693 7.89358 4.11079 7.89358 3.54811C7.89358 2.98544 7.42681 2.5293 6.85102 2.5293C6.27524 2.5293 5.80847 2.98544 5.80847 3.54811C5.80847 4.11079 6.27524 4.56693 6.85102 4.56693Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4681 4.71251C19.1261 4.71251 19.6596 4.19121 19.6596 3.54815C19.6596 2.90509 19.1261 2.38379 18.4681 2.38379C17.8101 2.38379 17.2766 2.90509 17.2766 3.54815C17.2766 4.19121 17.8101 4.71251 18.4681 4.71251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4681 4.71251C19.1261 4.71251 19.6596 4.19121 19.6596 3.54815C19.6596 2.90509 19.1261 2.38379 18.4681 2.38379C17.8101 2.38379 17.2766 2.90509 17.2766 3.54815C17.2766 4.19121 17.8101 4.71251 18.4681 4.71251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4681 4.56693C19.0439 4.56693 19.5106 4.11079 19.5106 3.54811C19.5106 2.98544 19.0439 2.5293 18.4681 2.5293C17.8923 2.5293 17.4255 2.98544 17.4255 3.54811C17.4255 4.11079 17.8923 4.56693 18.4681 4.56693Z",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85109 3.54819C6.55321 3.75195 5.18598 3.03005 5.36173 1.6823C5.39891 1.31473 5.56955 0.972328 5.84276 0.717091C6.11596 0.461853 6.47366 0.310659 6.85109 0.290888C6.85109 0.290888 7.80428 0.212293 8.11705 0.887623",
    stroke: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4681 3.54819C18.1702 3.75195 16.803 3.03005 16.9787 1.6823C17.0159 1.31473 17.1866 0.972328 17.4598 0.717091C17.733 0.461853 18.0907 0.310659 18.4681 0.290888C18.4681 0.290888 19.4213 0.212293 19.7341 0.887623",
    stroke: "#020303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fefb1f8a1ef0858f91f8b92b2d22c9fb.svg";
export { ForwardRef as ReactComponent };